import React, { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import { FaTimes, FaPen, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
import "./UserProfileCard.css";

export default function UserProfileCard({ userId, userEmail, profile, onProfileUpdate, onLogout, onClose }) {
  const [form, setForm] = useState({
    nome: profile?.nome || "",
    telefone: profile?.telefone || "",
    funcao: profile?.funcao || "",
    empresa: profile?.empresa || "",
    container: profile?.container || "",
  });
  const [avatarUrl, setAvatarUrl] = useState(profile?.avatar_url || "");
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [erro, setErro] = useState("");
  const fileInputRef = useRef(null);

  const incompleto = !form.nome || !form.empresa || !form.funcao || !form.container;

  useEffect(() => {
    setForm({
      nome: profile?.nome || "",
      telefone: profile?.telefone || "",
      funcao: profile?.funcao || "",
      empresa: profile?.empresa || "",
      container: profile?.container || "",
    });
    setAvatarUrl(profile?.avatar_url || "");
  }, [profile]);

  useEffect(() => {
    if (incompleto) setEditing(true);
  }, [incompleto]);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !userId) return;
    setUploading(true);
    setErro("");
    try {
      const ext = file.name.split(".").pop();
      const filePath = `avatars/${userId}.${ext}`;
      const { error: uploadError } = await supabase.storage
        .from("avatars")
        .upload(filePath, file, { upsert: true });
      if (uploadError) throw uploadError;
      const { data } = supabase.storage.from("avatars").getPublicUrl(filePath);
      setAvatarUrl(`${data.publicUrl}?v=${Date.now()}`);
      await supabase.from("profiles").update({ avatar_url: data.publicUrl }).eq("id", userId);
      onProfileUpdate?.((prev) => ({ ...prev, avatar_url: data.publicUrl }));
    } catch {
      setErro("Erro ao enviar imagem.");
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleSave = async () => {
    if (!form.nome.trim()) return setErro("Digite seu nome.");
    if (!form.empresa.trim()) return setErro("Digite sua empresa.");
    if (!form.funcao.trim()) return setErro("Digite sua função.");
    if (!form.container.trim()) return setErro("Nomeie seu container.");
    setSaving(true);
    setErro("");
    try {
      const { error } = await supabase
        .from("profiles")
        .upsert({ id: userId, email: userEmail, ...form }, { onConflict: "id" });
      if (error) throw error;
      onProfileUpdate?.((prev) => ({ ...prev, ...form }));
      setEditing(false);
    } catch {
      setErro("Erro ao salvar perfil.");
    } finally {
      setSaving(false);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    onLogout?.();
  };

  return (
  <div className="upc-overlay" onClick={incompleto ? undefined : onClose}>
    <div className="upc-card" onClick={(e) => e.stopPropagation()}>
      <div className="upc-header">
        {!incompleto && (
          <button className="upc-close" onClick={onClose}><FaTimes /></button>
        )}
        {!editing && (
          <button className="upc-edit-btn" onClick={() => setEditing(true)}><FaPen /></button>
        )}
        <div className="upc-avatar-wrap">
          {avatarUrl ? <img src={avatarUrl} alt="Avatar" /> : <FaUserCircle className="upc-avatar-placeholder" />}
          {editing && (
            <label className="upc-avatar-edit">
              {uploading ? "Enviando..." : "Alterar foto"}
              <input type="file" ref={fileInputRef} accept="image/*" hidden onChange={handleFileChange} />
            </label>
          )}
        </div>
      </div>

      <div className="upc-identity">
        <h3>{form.nome || "Seu nome"}</h3>
        <span>{form.funcao || "Função não definida"}</span>
      </div>

      <div className="upc-body">
        <div className="upc-field">
          <label>Nome</label>
          {editing ? <input value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} /> : <span>{form.nome || "—"}</span>}
        </div>

        <div className="upc-field">
          <label>Email</label>
          <span className="upc-field--locked">{userEmail}</span>
        </div>

        <div className="upc-field">
          <label>Telefone celular</label>
          {editing ? <input value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} placeholder="(00) 00000-0000" /> : <span>{form.telefone || "—"}</span>}
        </div>

        <div className="upc-field">
          <label>Função</label>
          {editing ? <input value={form.funcao} onChange={(e) => setForm({ ...form, funcao: e.target.value })} /> : <span>{form.funcao || "—"}</span>}
        </div>

        <div className="upc-field">
          <label>Empresa</label>
          {editing ? <input value={form.empresa} onChange={(e) => setForm({ ...form, empresa: e.target.value })} /> : <span>{form.empresa || "—"}</span>}
        </div>

        <div className="upc-field">
          <label>Nome do seu container</label>
          {editing ? <input value={form.container} onChange={(e) => setForm({ ...form, container: e.target.value })} placeholder="Ex: Projeto OnBox Principal" /> : <span>{form.container || "—"}</span>}
        </div>

        {erro && <p className="upc-erro">{erro}</p>}

        {editing ? (
          <button className="upc-save-btn" onClick={handleSave} disabled={saving || uploading}>
            {saving ? "Salvando..." : "Salvar alterações"}
          </button>
        ) : (
          <button className="upc-logout-btn" onClick={handleLogout}><FaSignOutAlt /> Sair</button>
        )}
      </div>
    </div>
  </div>
);
}